import { Component, inject } from '@angular/core';
import { ButtonComponent } from '../../../assets/shared/button/button.component';
import { Router } from '@angular/router';

@Component({
    selector: 'not-found',
    imports: [ButtonComponent],
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  router: Router = inject(Router);

  handleNavigate() {
    this.router.navigate(['/']);
  }
}
